import { AdBiddingProvider, IAdBiddingProviderConfig } from '../../../'
import { logger } from '../../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../../utils/dom'
import { IAd } from '../../../../ad'
import { AdBiddingBase } from '../base'

interface IWindow {
    apstag: any
    googletag: any
    deployads: any
}

declare let window: IWindow

class Amazon extends AdBiddingBase {
    public requestAds: undefined
    protected URLPath: string
    protected waitForBidder = true
    private defaultAdServer = 'googletag'
    private defaultTimeoutMs = '2e3'
    private oopSizes = [[1, 1]]

    constructor() {
        super()
        this.URLPath = '//c.amazon-adsystem.com/aax2/apstag.js'
    }

    public initializeBidding(
        confs: IAdBiddingProviderConfig[],
        adServer = this.defaultAdServer,
        timeout = this.defaultTimeoutMs
    ): void {

        const conf = confs.find((_) => _.client === AdBiddingProvider.AMAZON)
        if (conf) {
            this.amazonEnabled = true

            // setup global object
            window.apstag = window.apstag || {
                _Q: [],
                fetchBids: (...a: any[]) => window.apstag._Q.push(['f', a]),
                init: (...a: any[]) => window.apstag._Q.push(['i', a]),
                setDisplayBids: (): void => undefined, // ?
            }

            // configure
            window.apstag.init({
                adServer,
                bidTimeout: timeout,
                pubID: conf.account,
            })

            DOMUtils.loadScript(this.URLPath)
            logger(`debug`, `Initialize Amazon bidder: ${this.URLPath}`)
        }
    }

    public async requestAdsPromise(ads?: IAd[]): Promise<undefined> {
        return new Promise((resolve: any, _): void => {

            logger('info', `AMZ amazonEnabled = ${this.amazonEnabled}`)

            if (!this.amazonEnabled) {
                return
            }

            const slots = (ads || []).map((ad) => ({
                sizes: ad.isOutOfPage() ? this.oopSizes : ad.sizes,
                slotID: ad.id,
            }))

            // no ads to bid on
            if (!slots.length) {
                return
            }

            // fetch bids
            window.apstag.fetchBids({ slots }, () =>
                window.googletag.cmd.push(() => {
                    // sets bid info via targeting
                    window.apstag.setDisplayBids()
                    logger('info', 'Amazon bidder has resolved')
                })
            )
            resolve()
        })
    }
}

export default Amazon
